import React, { memo, useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { createSelector } from 'reselect';
import styles from './DownloadTask.module.less';

import { logging } from '../../actions/log';
import { CONTEXT } from '../../config';
import { mySoftKeys, todayDownloadApp } from '../../constants/storageKeys';
import { PCStoreJsBridge } from '../../nativeapi';
import { renderSize } from '../../utils/utils';
import Toast from '../../components/Toast/Toast';

import { setDownloadVisible, setInTimeInstalledSoft } from '../../actions/layout';
import {
  downloadCancelSoft,
  downloadGetSoftList,
  downloadShowSIM,
  downloadCanenl,
} from '../../actions/downloadTask';
import { isTemplateHead } from 'typescript';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

const selectDownloadSofts = createSelector(
  state => state.downloadTask,
  downloadTask => downloadTask.softs,
);

const selectOtherInfo = createSelector(
  state => state.native,
  native => native.otherInfo,
);
const selectUserInfo = createSelector(
  state => state.user,
  user => user.userInfo,
);

const DownloadStatusMsg = {
  pre: '准备中',
  wait: '等待下载...',
  pause: '下载已暂停，点击继续',
  dl: '下载中',
  err: '任务异常',
  i: '安装中...',
  exitq: '任务结束',
};
const logSoftStatus = {};
const LoginCheckSoft = null; // 登录时候记录当前要反馈的下载应用状态
export default memo(() => {
  const history = useHistory();
  const dispatch = useDispatch();
  const logInfoData = useSelector(selectLogInfo);
  const downloadSofts = useSelector(selectDownloadSofts); // 正在下载
  const otherInfo = useSelector(selectOtherInfo);
  const userInfo = useSelector(selectUserInfo);
  const [downloadSoftsF, setDownloadSoftsF] = useState([]);

  useEffect(() => {
    let softsF = downloadSofts.filter(item => {
      return item.attr && item.attr.status !== 'exitq';
    });
    setDownloadSoftsF(softsF);
  }, [downloadSofts]);

  const loggingButtonStatus = useCallback(
    (action, item, status, isCheck) => {
      if (!item.pc && !item.apk && !item.attr) {
        return;
      }
      let key = item.type === 'pc' ? item.pc.SoftID : item.apk.pkg;
      let app = item.type === 'pc' ? item.pc : item.apk;
      if (isCheck || (logSoftStatus[key] && !logSoftStatus[key][action])) {
        // 按钮状态变化打桩
        let logInfo_ = {};
        try {
          logInfo_ = app.LogInfo ? JSON.parse(app.LogInfo) : {};
        } catch (error) {}

        const logParam2 = {
          source: logInfo_?.source || logInfoData.source,
          ...logInfo_,
          pkg: app.pkg,
          vc: app.vc,
          vn: app.vn,
          softid: app.SoftID || app.pkg,
          softName: app.softName || app.SoftName,
          version: app.Version || app.version,
          taskid: item?.attr?.taskId,
        };
        // 1 表示成功   2 表示失败   3 表示暂停
        logParam2.status = status || '';
        logParam2.softType = item.type === 'pc' ? '0' : '1';
        logParam2.mes = item?.attr?.msg || '';
        logParam2.speed = item?.attr?.avspeed || 0;
        logParam2.progress = item?.attr?.progress || 0;
        logParam2.dlspeed = item?.attr?.dlspeed || 0;
        logParam2.dlsz = item?.attr?.dlsz || 0;
        dispatch(
          logging({
            category: 'R',
            action,
            label: '',
            param2: logParam2,
            param3: item?.BizInfo || app.BizInfo || '',
          }),
        );
      }
    },
    [logInfoData],
  );

  const clearLogSoftStatus = useCallback(item => {
    let key = item.type === 'pc' ? item.pc.SoftID : item.apk.pkg;
    if (logSoftStatus[key]) {
      let time_index = setTimeout(() => {
        logSoftStatus[key] = null;
        clearTimeout(time_index);
      }, 500);
    }
  }, []);

  useEffect(() => {
    downloadSofts.forEach(item => {
      if (!item.pc && !item.apk && !item.attr) {
        return;
      }
      let key = item.type === 'pc' ? item.pc.SoftID : item.apk.pkg;
      if (!logSoftStatus[key]) {
        logSoftStatus[key] = {};
      }
      if (item.attr.act === 'pause') {
        if (!logSoftStatus[key]['D_pause']) {
          loggingButtonStatus('D_pause', item);
          loggingButtonStatus('D_Ed', item, 3, true);
        }
        logSoftStatus[key]['D_pause'] = true;
        logSoftStatus[key]['D_resume'] = false;
      } else if (item.attr.act === 'resume') {
        if (!logSoftStatus[key]['D_resume']) {
          // 继续的通知，之后会有sDl通知，所以设置D_Sd为没有上报
          loggingButtonStatus('D_resume', item);
          logSoftStatus[key]['D_Sd'] = false;
        }
        logSoftStatus[key]['D_pause'] = false;
        logSoftStatus[key]['D_resume'] = true;
      } else if (item.attr.act === 'reTask') {
        // 重试的流程，之后的桩都重新报
        loggingButtonStatus('D_reTask', item);
        logSoftStatus[key]['D_Sd'] = false;
        logSoftStatus[key]['D_Ed'] = false;
        logSoftStatus[key]['I_Si'] = false;
        logSoftStatus[key]['I_Ei'] = false;
        logSoftStatus[key]['Err'] = false;
      } else if (item.attr.act === 'sDL') {
        loggingButtonStatus('D_Sd', item);
        logSoftStatus[key]['D_Sd'] = true;
      } else if (item.attr.act === 'eDL') {
        loggingButtonStatus('D_Ed', item, 1);
        logSoftStatus[key]['D_Ed'] = true;
        // 记录当前是否点击下载过app, 用于判断是否可以领取礼包 v7.4新增逻辑 2021-8-20 15:23:36
        let downloadApp = sessionStorage.getItem(todayDownloadApp);
        sessionStorage.setItem(todayDownloadApp, `${downloadApp},${key}`);
      } else if (item.attr.act === 'sInst') {
        loggingButtonStatus('D_Ed', item, 1);
        loggingButtonStatus('I_Si', item);
        logSoftStatus[key]['D_Ed'] = true;
        logSoftStatus[key]['I_Si'] = true;
        // 记录当前是否点击下载过app, 用于判断是否可以领取礼包 v7.4新增逻辑 2021-8-20 15:23:36
        let downloadApp = sessionStorage.getItem(todayDownloadApp);
        sessionStorage.setItem(todayDownloadApp, `${downloadApp},${key}`);
      } else if (item.attr.act === 'eInstSucc') {
        // 安装完成 installed===true成功
        loggingButtonStatus('I_Ei', item, item.attr.installed ? 1 : 2);
        logSoftStatus[key]['I_Ei'] = true;
      } else if (item.attr.act === 'eInst') {
        // 安装完成 installed===true成功
        loggingButtonStatus('I_Ei_End', item, item.attr.installed ? 1 : 2);
        logSoftStatus[key]['I_Ei_End'] = true;

        if (item.type === 'apk' && item.attr.installed) {
          let soft = item.apk;
          // 安卓安装成功后，判断添加显示小红点
          if (!soft.logInfo || (soft.logInfo && soft.logInfo.type !== 'u')) {
            const spotSoftStr = localStorage.getItem(mySoftKeys.RED_SPOT_SOFT);
            let spotSofts = [];
            if (spotSoftStr) {
              spotSofts = spotSoftStr.split(',');
            }
            if (spotSofts.indexOf(soft.pkg) === -1) {
              spotSofts.push(soft.pkg);
              localStorage.setItem(mySoftKeys.RED_SPOT_SOFT, spotSofts.join(','));
            }
          }
          // 安卓安装成功后，添加显示安装完成提示。
          dispatch(
            setInTimeInstalledSoft({
              appInfo: {
                ...soft,
                packageName: soft.pkg,
                versionCode: soft.vc,
                softName: soft.SoftName,
                logoFile: soft.LogoFile,
              },
              time: +new Date(),
            }),
          );
        }

        clearLogSoftStatus(item);
      } else if (item.attr.act === 'cancel') {
        if (item.attr.statFrom === 'dl') {
          loggingButtonStatus('D_Ed', item, 2);
          logSoftStatus[key]['D_Ed'] = true;
        }
        clearLogSoftStatus(item);
      } else if (item.attr.act === 'error') {
        // 当任务没有结束直接报失败，判断一下为下载失败还是安装失败
        if (item.attr.statFrom == 'dl') {
          loggingButtonStatus('D_Ed', item, 2);
          logSoftStatus[key]['D_Ed'] = true;
        } else if (item.attr.statFrom == 'i') {
          loggingButtonStatus('I_Ei', item, 2);
          logSoftStatus[key]['I_Ei'] = true;
          if (item?.attr?.eCode === -42005) {
            dispatch(downloadShowSIM('SIM_64'));
          }
        }
        loggingButtonStatus('Err', item, 2);
        logSoftStatus[key]['Err'] = true;
      }
    });
  }, [dispatch, downloadSofts]);

  const handleStopProp = useCallback(ev => {
    ev.stopPropagation();
  }, []);

  const handleDownloadHidden = useCallback(() => {
    dispatch(setDownloadVisible(false));
  }, [dispatch]);

  const handleOpenDownloadFolder = useCallback(() => {
    // 点击 打开下载目录 打桩
    dispatch(
      logging({
        category: 'C',
        action: 'Dir',
        label: '',
        param2: {
          source: 'D_Task',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        },
      }),
    );
    if (otherInfo.DownLoadPath) {
      PCStoreJsBridge.openFolder(otherInfo.DownLoadPath);
    } else {
      PCStoreJsBridge.openFolder(otherInfo.DefaultPath);
    }
  }, [otherInfo]);

  useEffect(() => {
    // 检测到登录信息变化，则继续提交
    const login_status = window.CallNativeMethod && window.CallNativeMethod('get_login_status');
    if (login_status === '1' && userInfo.st && LoginCheckSoft) {
      handleUserFeedback(LoginCheckSoft);
    }
  }, [userInfo]);

  const handleUserFeedback = useCallback(item => {
    let soft = item.type === 'pc' ? item.pc : item.apk;
    let softID = item.type === 'pc' ? item.pc.SoftID : item.apk.pkg;
    const login_status = window.CallNativeMethod && window.CallNativeMethod('get_login_status');
    if (login_status !== '1') {
      window.CallNativeMethod('login');
      LoginCheckSoft = soft;
      return;
    }

    dispatch(
      logging({
        category: 'C',
        action: 'Download_Feedback',
        label: '',
        param2: {
          source: 'HomePage',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        },
      }),
    );
    PCStoreJsBridge.submitFeedbackInfo({
      feedbackType: '2',
      feedbackMessage: `${soft.mes} ${soft.code}`,
      contactInfo: `下载失败反馈: ${JSON.stringify({
        softID: softID,
        softName: soft.softName,
        // ...item.attr,
        time: new Date(),
      })}`,
      checkLog: true,
      picArray: [],
      taskID: soft.taskid,
    }).then(
      () => {
        Toast.success({
          content: '反馈成功！',
        });
      },
      () => {
        Toast.success({
          content: '反馈失败！',
        });
      },
    );
  }, []);

  const loggingHandle = useCallback(
    (acttion, item) => {
      let key = item.type === 'pc' ? item.pc.SoftID : item.apk.pkg;
      let app = item.type === 'pc' ? item.pc : item.apk;
      // 点击 取消下载 打桩
      dispatch(
        logging({
          category: 'C',
          action: acttion,
          label: '',
          param2: {
            source: 'D_Task',
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            softid: item.type === 'apk' ? item.apk.pkg : item.pc.SoftID,
            softType: item.type === 'apk' ? '1' : '0',
          },
          param3: item.BizInfo || app.BizInfo,
        }),
      );
    },
    [dispatch, logInfoData],
  );

  const handleCancel = useCallback(item => {
    if (item?.type === 'apk' && item?.attr?.act === 'sPre') {
      dispatch(downloadCanenl({ isShow: true, info: item }));
    } else {
      loggingHandle('Cancel', item);
      dispatch(downloadCancelSoft({ ...item }));
    }
  }, []);
  const handlePause = useCallback(item => {
    loggingHandle('Pause', item);
    PCStoreJsBridge.downloadPause({ ...item });
  }, []);
  const handleResume = useCallback(item => {
    loggingHandle('Resume', item);
    PCStoreJsBridge.downloadResume({ ...item });
  }, []);
  const handleRetry = useCallback(item => {
    loggingHandle('Retry', item);
    PCStoreJsBridge.downloadRetry({ ...item });
  }, []);

  return (
    <div
      className={styles.download_task}
      onClick={handleStopProp}
      onMouseDown={handleStopProp}
      onTouchStart={handleStopProp}
    >
      <div className={'task_header'}>
        <div className={'task_title'}>
          任务管理{downloadSoftsF.length > 0 && `(${downloadSoftsF.length})`}
        </div>
        <div className={'task_close iconfont icon-close'} onClick={handleDownloadHidden}></div>
      </div>
      <div className={'task_body'}>
        {downloadSoftsF.length === 0 && (
          <div className="task_default">
            <div className="task_default_img"></div>
            <div className="task_default_text">
              <p>当前暂无下载任务</p>
              <p>快去推荐板块发现更多精彩内容</p>
            </div>
          </div>
        )}
        {downloadSofts.map((item, i) => {
          let backgroundImage = '';
          if (item.attr.status === 'i' || item.attr.status === 'exitq') {
            backgroundImage = `linear-gradient(to right, #F2FBF7 100%, #fff 100%)`;
          } else if (
            item.attr.status === 'dl' ||
            item.attr.status === 'pause' ||
            item.attr.status === 'err'
          ) {
            backgroundImage = `linear-gradient(to right, #F2FBF7 ${
              item.attr.progress || 0
            }%, #fff ${item.attr.progress || 0}%)`;
          }
          if (
            item.attr.status === 'exitq' ||
            item.attr.act === 'eInst' ||
            item.attr.act === 'cancel'
          ) {
            return;
          }
          return (
            <div
              className={'task_line'}
              key={i}
              style={{
                backgroundImage: backgroundImage,
              }}
            >
              <div className={'task_line_img_box'}>
                {item.type === 'pc' && item.pc && (
                  <img className={'task_line_img'} src={item.pc.LogoFile} />
                )}
                {item.type === 'apk' && item.apk && (
                  <>
                    <img className={'task_line_img'} src={item.apk.LogoFile} />
                    <div className={'task_line_img_and'}></div>
                  </>
                )}
              </div>
              <div className={'task_line_cont'}>
                {item.type === 'pc' && item.pc && (
                  <div className={'task_line_softname'} title={item.pc.SoftName}>
                    {item.pc.SoftName}
                  </div>
                )}
                {item.type === 'apk' && item.apk && (
                  <div className={'task_line_softname'} title={item.apk.SoftName}>
                    {item.apk.SoftName}
                  </div>
                )}
                <div className={'task_line_infos'}>
                  {/* 准备中 */}
                  {item.attr.status === 'pre' && (
                    <span className="task_line_text">{DownloadStatusMsg[item.attr.status]}</span>
                  )}
                  {/* 排队等待中 */}
                  {item.attr.status === 'wait' && (
                    <span className="task_line_text">{DownloadStatusMsg[item.attr.status]}</span>
                  )}
                  {/* 暂停中 */}
                  {item.attr.status === 'pause' && (
                    <span className="task_line_text">{DownloadStatusMsg[item.attr.status]}</span>
                  )}
                  {/* 下载中 */}
                  {item.attr.status === 'dl' && (
                    <>
                      <span className="task_line_text">
                        {`${(item.attr.progress || 0).toFixed(0)}%`}
                      </span>
                      <span className="task_line_text_speed">
                        {`${renderSize(item.attr.dlspeed || 0)}/s`}
                      </span>
                    </>
                  )}
                  {/* 安装中 */}
                  {item.attr.status === 'i' && (
                    <span className="task_line_text">{DownloadStatusMsg[item.attr.status]}</span>
                  )}
                  {/* 错误 msg==='Sim interrupt' 是个特殊值，表示取消模拟器安装*/}
                  {item.attr.status === 'err' && (
                    <>
                      {item.attr.msg === 'Sim interrupt' && (
                        <span className="task_line_text_err_apk">已取消安卓模拟器安装</span>
                      )}
                      {item.attr.msg !== 'Sim interrupt' && (
                        <>
                          <span className="task_line_text_err">
                            {/* {item.attr.statFrom === 'dl'
                          ? '下载失败，请重试'
                          : item.attr.msg || DownloadStatusMsg[item.attr.status]} */}
                            下载失败，请重试
                          </span>
                          <div
                            className={'task_line_feedback'}
                            onClick={() => {
                              handleUserFeedback(item, downloadSofts);
                            }}
                          >
                            一键反馈
                          </div>
                        </>
                      )}
                    </>
                  )}
                  {/* 退出列表 */}
                  {item.attr.status === 'exitq' && (
                    <span className="task_line_text">{DownloadStatusMsg[item.attr.status]}</span>
                  )}
                </div>
              </div>
              <div className={'task_line_opt'}>
                {/* 下载中显示可暂停 */}
                {item.attr.status === 'dl' && (
                  <div className={'task_line_opt_text'} onClick={() => handlePause(item)}>
                    暂停
                  </div>
                )}
                {/* 暂停中显示可继续 */}
                {item.attr.status === 'pause' && (
                  <div className={'task_line_opt_text_'} onClick={() => handleResume(item)}>
                    继续
                  </div>
                )}
                {/* 错误显示可重试 */}
                {item.attr.status === 'err' && (
                  <div className={'task_line_opt_text_'} onClick={() => handleRetry(item)}>
                    重试
                  </div>
                )}
                {/* 操作 */}
                {item.attr.status === 'i' || item.attr.status === 'pre' ? (
                  <>
                    {item?.type === 'apk' && item?.attr?.act === 'sPre' ? (
                      <>
                        <div
                          className={
                            'task_line_opt_cancel  iconfont icon-task_cancel task_line_opt_cancel_apk'
                          }
                          onClick={() => handleCancel(item)}
                        />

                        <div
                          className={
                            'task_line_opt_installing iconfont icon-task_wait task_line_opt_installing_apk'
                          }
                        />
                      </>
                    ) : (
                      <div className={'task_line_opt_installing iconfont icon-task_wait'} />
                    )}
                  </>
                ) : (
                  <div
                    className={'task_line_opt_cancel  iconfont icon-task_cancel'}
                    onClick={() => handleCancel(item)}
                  />
                )}
              </div>
            </div>
          );
        })}
      </div>
      <div className={'task_footer'}>
        <span onClick={handleOpenDownloadFolder}>打开下载目录</span>
      </div>
    </div>
  );
});
